import { getBrowserBridgeAPI } from '@atlassian/rovo-content-bridge-api';
import {
	AifcExperienceTrackingCommand,
	type AifcExperienceTrackingCommandProperties,
	ROVO_CHAT_CLIENT_ID,
	ROVO_EXPERIENCE_TRACKING_SENDER_CLIENT_ID,
} from '@atlassian/rovo-content-bridge-api-commands';

/**
 * Sends a bridge command to update the status of an experience running at the Rovo chat level
 *
 * @param props - Experience tracking properties (status, actionType, actionId, etc.)
 * @param props.status - the status of the experience (success, fail, abort)
 * @param props.actionType - content type, like 'page' | 'whiteboard' | 'database'
 * @param props.actionId - should be contentId
 * @param props.contentContext - where the content is being used in relation to rovo: 'staging-area' | 'global'
 * @param props.experienceName - experience name should come from '@atlassian/conversation-assistant-instrumentation'
 * @param props.attributes - optional arbitrary key-value pairs to include in the experience event's attributes
 */
export const sendAIFCExperienceTrackingToParent = (
	props: Omit<AifcExperienceTrackingCommandProperties, 'senderId' | 'receiverId'>,
): void => {
	const api = getBrowserBridgeAPI();
	const senderId = ROVO_EXPERIENCE_TRACKING_SENDER_CLIENT_ID;
	const receiverId = ROVO_CHAT_CLIENT_ID;
	let payload: AifcExperienceTrackingCommandProperties;

	switch (props.status) {
		case 'fail':
			payload = {
				...props,
				error: typeof props.error === 'string' ? props.error : 'Unknown error',
				reason: undefined,
				senderId,
				receiverId,
			} as AifcExperienceTrackingCommandProperties;
			break;
		case 'abort':
			payload = {
				...props,
				reason: typeof props.reason === 'string' ? props.reason : 'Aborted',
				error: undefined,
				senderId,
				receiverId,
			} as AifcExperienceTrackingCommandProperties;
			break;
		case 'success':
		default:
			payload = {
				...props,
				error: undefined,
				reason: undefined,
				senderId,
				receiverId,
			} as AifcExperienceTrackingCommandProperties;
			break;
	}
	void api?.send(AifcExperienceTrackingCommand, payload);
};
